export const ROUTERS = {
    USER: {
        HOME: "",
        HOT_BOOK: "/books/hot-book",
        BEST_SELLER_BOOK: "/books/best-seller-book",
        SIGNIN: "/login",
        REGISTER: "/register",
        PRODUCT_DETAILS: "/details/:slugID",
        CARTITEMS: "/cart-items",
        CONFIRMORDER: "/confirm-order",
        PRODUCT_LISTING: "/listing/:slug",
        PERSONAL_INFOR: "/personal-infor",
        ORDER_SUCCESS: "/order-success/:orderID",
        PAYMENT_ONLINE: "/payment-online",
        PRODUCT_SEARCH: "/books",
        ORDER_DETAILS: "/order-details",
        CANCEL_PAYMENTLINK: "/cancel-paymentLink",
        ORDER_STATUS: "/order-status/:status",
        VERYFI_EMAIL: "/verify-email",
        FORGOT_PASSWORD: "/forgot-password",
        RESET_PASSWORD: "/reset-password",
        PRIVACY_POLICY: "/privacy-policy",
        CANCEL_ORDER: "/cancel-order"
    },

    ADMIN: {
        DASHBOARD: "/admin",
        ADD_BOOK: "/admin/add-book",
        UPDATE_BOOK: "/admin/update-book",
        LIST_BOOK: "/admin/list-book/:slug",
        LIST_CATEGORY: "/admin/list-category",
        LISTORDER: "/admin/list-order/:status",
        LIST_REVIEW: "/admin/list-review/:status",
        REVENUE_STATISTICS: "/admin/revenue-statistics",
        CAMPAIGN: "/admin/campaign",
        BOOK_DETAILS: "/admin/detail/:id",
        LIST_CUSTOMER: "/admin/list-customer/:slug",
        ADMIN_MANAGEMENT: "/admin/list-admin/:slug",
        CHANGE_PASSWORD: "/admin/change-password",
        MY_ACCOUNT: "/admin/my-account"
    }
}